import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// import { simpleFitCell } from './FitnessTrackerListe';
import { AgtSocialMediaVM } from 'app/stores/ui/agt.socialmedia.ui.store';
import { Icon } from 'app/components/common/Icon';
import { formatNum, formatNumTwoDig } from 'app/utils';
import { SocialMediaBmRangeOptions } from './SocialMediaOptions';

export const InstagramListe = observer(() => {
	const { berichteUiiStore, agtSocialMediaUiStore, agenturListUiStore, session } = useStore();
	const [hasItems, setHasItems] = useState(false);
	const tm = new TableModel<AgtSocialMediaVM, number>();
	const cols: ITableColumn<AgtSocialMediaVM, number>[] = [];

	const currentYear = agtSocialMediaUiStore.currentYear;

	cols.push({
		label: 'Agentur',
		path: 'agt.name',
		sortBy: 'agt.name',
		render: AgenturNameCell,
	});

	if (session.isMulti || session.isAdmin) {
		cols.push({
			label: 'GP',
			path: 'hasMoreThan30kViewsMultiGp26',
			render(row) {
				return <>{row.data.hasMoreThan30kViewsMultiGp26 ? <Icon iconClass="check-circle" faModifier="far" /> : <></>}</>;
			},
			agg: [
				{
					aggType: AggregrationType.count,
				},
			],
		});
		cols.push({
			label: 'Teilhaber',
			path: `agt.thCount`,
			agg: [
				{
					aggType: AggregrationType.sum,
				},
			],
		});
	}

	cols.push({
		label: 'Link',
		path: 'currInsta.link',
		sortBy: 'currInsta.link',

		render: (row: TableRow<AgtSocialMediaVM>) => {
			return row.data.currInsta && row.data.currInsta.url ? (
				<a href={row.data.currInsta?.url} className="color-primary" target="_blank" rel="noreferrer">
					<Icon iconClass="external-link" />
				</a>
			) : (
				<></>
			);
		},
	});

	cols.push({
		label: 'Status',
		path: `currInsta.status`,
		sortBy: `currInsta.status`,
		agg: [{ aggType: AggregrationType.count }],
		render: (row: TableRow<AgtSocialMediaVM>) => <>{row.data.currInsta && row.data.currInsta.status === 1 ? <Icon iconClass="check" /> : ''}</>,
	});

	cols.push({
		label: 'Follower',
		path: `currInsta.follow`,
		sortBy: `currInsta.follow`,
		agg: [{ aggType: AggregrationType.avg }],
	});

	cols.push({
		label: 'Follower VJ',
		path: `prevInsta.follow`,
		sortBy: `prevInsta.follow`,
		agg: [{ aggType: AggregrationType.avg }],
	});

	cols.push({
		label: `Beiträge ${currentYear}`,
		path: `instaPostsYtd`,
		sortBy: `instaPostsYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: `Eigene Beiträge ${currentYear}`,
		path: `instaOwnPostsYtd`,
		sortBy: `instaOwnPostsYtd`,
		agg: [
			{
				aggType: AggregrationType.avg,
				aggIf: (val: any) => val >= 0,
				format: formatNumTwoDig,
			},
		],
		format: formatNum,
	});

	cols.push({
		label: `Ansichten ${currentYear}`,
		path: `instaViewsYtd`,
		sortBy: `instaViewsYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: 'Abo PR',
		path: `currInsta.aboPr`,
		sortBy: `currInsta.aboPr`,
		agg: [{ aggType: AggregrationType.count }],
		render: (row: TableRow<AgtSocialMediaVM>) => <>{row.data.currInsta && row.data.currInsta.aboPr === 1 ? <Icon iconClass="check" /> : ''}</>,
	});

	tm.sortBy = 'agt.name';
	tm.setCols(cols);

	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtSocialMediaUiStore.loadBySelectedRange().then((vms) => {
			let items = vms.filter((x) => x.instas.length > 0);
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtSocialMediaVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtSocialMediaUiStore, agtSocialMediaUiStore.selectedMinBm, agtSocialMediaUiStore.selectedMaxBm]);

	return (
		<>
			<SocialMediaBmRangeOptions />
			{!hasItems ? (
				<div className="pad-1rem">Keine Daten gefunden</div>
			) : (
				<>
					<Table stickyHeader={true} tm={tm} stickyFooter={true}></Table>
				</>
			)}
		</>
	);
});
